var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyFsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "FS_Icon_White",
    "data-name": "FS Icon_White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.381,
    height: 49.381,
    viewBox: "0 0 49.381 49.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M-12.267,2243.572v-6.054H20.954v-16.789H-12.267V2204.3H27.007v6.053H-6.214v4.323H27.007v28.9Zm-10.107,0v-49.381H27.007v6.053H-16.321v25.81H16.9v6.053H-16.321v11.464Z",
    transform: "translate(22.374 -2194.191)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyFsWhite);
export default __webpack_public_path__ + "static/media/company-fs-white.a4f74e763b6267d4a27fb5d4504feb59.svg";
export { ForwardRef as ReactComponent };